<template>
  <div class="container">
    <h1 class="mb-4" v-if="prospect.type == 'Fisica'">{{ prospect.name }}</h1>
    <h1 class="mb-4" v-else>{{ prospect.corporate_name }}</h1>

    <div class="details">
      <div class="details__head">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#details">
              <fai icon="info"/>&nbsp;Generales
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#log">
              <fai icon="address-book"/>&nbsp;Bitácora de contacto
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#tasks">
              <fai icon="tasks"/>&nbsp;Tareas
            </a>
          </li>
        </ul>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Details -->
          <div id="details" class="tab-pane fade show active" role="tabpanel" v-if="prospect.id">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="m--font-info">Datos Generales</h4>
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-info" @click="goToEdit">
                  <fai :icon="['far','edit']"/> Editar
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Nombre</h5>
                  <span>{{ prospect.name }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Apellido Paterno</h5>
                  <span>{{ prospect.lastname_father }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Apellido Materno</h5>
                  <span>{{ prospect.lastname_mother }}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Correo electrónico</h5>
                  <span>{{ prospect.email }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Teléfono</h5>
                  <span>{{ prospect.telephone }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Teléfono</h5>
                  <span>{{ prospect.mobile }}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Nacionalidad</h5>
                  <span>{{ prospect.nationality }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Fecha de nacimiento</h5>
                  <span>{{ prospect.dob | reverseDate }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>RFC</h5>
                  <span>{{ prospect.rfc }}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Tipo</h5>
                  <span>{{ prospect.type }}</span>
              </div>
              <div class="col-sm-4" v-if="prospect.type == 'Moral'">
                  <h5>Razón Social</h5>
                  <span>{{ prospect.corporate_name }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Estatus</h5>
                  <span>{{ prospect.status_description }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Promotor</h5>
                  <span>{{ prospect.promoter_name }}</span>
              </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
                <div class="col-sm col-md col-lg">
                    <h4 class="m--font-info">Datos de inversión</h4>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-4">
                    <h5>Inversión Mínima</h5>
                    <span>{{ prospect.investment | formatCurrency }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Monto de Inversión Máxima</h5>
                    <span>{{ prospect.investment_end | formatCurrency }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Tasa de Interes</h5>
                    <span>{{ prospect.interest}}%</span>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-4">
                    <h5>Fecha de Inversión desde</h5>
                    <span>{{ prospect.investment_date }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Fecha de Inversión hasta</h5>
                    <span>{{ prospect.investment_date_end }}</span>
                </div>
            </div>
          </div>
          <!--end: Details -->
          <!--begin: Log -->
          <div id="log" class="tab-pane fade" role="tabpanel" v-if="prospect.id">
            <sys-table :headers="entries_headers"
                       :items="entries"
                       title="Bitácora de contacto"
                       create_route="entry_create"
                       :create_route_params="{type: 'prospect', id: prospect.id}"
                       error_message="No se encontraron entradas"
                       title_icon="address-book"/>
          </div>
          <!--end: Log -->
          <!--begin: Tasks -->
          <div id="tasks" class="tab-pane fade" role="tabpanel" v-if="prospect.id">
            <sys-table :headers="tasks_headers"
                       :items="tasks"
                       title="Tareas"
                       create_route="task_create"
                       :create_route_params="{ type: 'prospect', id: prospect.id }"
                       update_route="task_update"
                       :update_route_params="{ type: 'prospect', prospect_id: prospect.id }"
                       error_message="No se encontraron tareas"
                       title_icon="tasks"/>
          </div>
          <!--end: Tasks -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import prospectsService from '@/services/prospects'
import SysTable from '@/components/shared/Table'

export default {
  name: 'ProspectDetail',

  components: { SysTable },

  data () {
    return {
      prospect: {},
      entries_headers: [
        { text: 'Titulo', value: 'title' },
        { text: 'Notas', value: 'content' },
        { text: 'Fecha', value: 'created_at' },
        { text: 'Autor', value: 'created_by' }
      ],
      entries: [],
      tasks_headers: [
        { text: 'Titulo', value: 'title' },
        { text: 'Notas', value: 'content' },
        { text: 'Fecha', value: 'date' },
        { text: 'Autor', value: 'created_by' },
        { text: 'Estatus', value: 'status_description' }
      ],
      tasks: []
    }
  },
  created: function () {
    const id = this.$route.params.id
    prospectsService.getById(id).then(res => {
      this.prospect = res.data
      this.entries = this.prospect.entries
      this.tasks = this.prospect.tasks
    })
      .catch(res => {
        console.log(res)
        this.$router.push({ name: 'prospect', params: { id } })
      })
  },
  methods: {
    goToEdit () {
      const id = this.$route.params.id
      this.$router.push({ name: 'prospect_update', params: { id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/prospects/ProspectDetail.vue